<template>
    <v-container>
        <v-overlay :value="isLoading">
            <v-progress-circular :size="70" :width="7" indeterminate></v-progress-circular>
        </v-overlay>
        <!-- ============================================= -->
        <v-text-field outlined dense hide-details="false" v-model="keywordFilter" label="キーワードフィルター" @change="buildDeviceTree()" v-show="!isLoading"></v-text-field>
        <!-- ============================================= -->
        <div v-for="obj in deviceTree" :key="obj.device.id">
            <v-card class="blue darken-2 my-3">
                <v-carousel height="auto" hide-delimiters show-arrows-on-hover :show-arrows="true" :continuous="false">
                    <v-carousel-item>
                        <v-card-text class="white--text pa-1">
                            <h2 class="ma-2 text-center">
                                {{ obj.device.name }}
                                <!--
                                <v-icon color="yellow" v-show="chkAlive(obj.device.alived_at)">mdi-alert</v-icon>
                                -->
                            </h2>
                            <!-- ============================================= -->
                            <div class="text-left" v-show="obj.sensor.motor_overcurrent">
                                <span class="red white--text font-weight-bold mx-1 px-3">過電流</span>
                            </div>
                            <div class="text-left" v-show="obj.sensor.timeout_winch_down">
                                <span class="red white--text font-weight-bold mx-1 px-3">下降タイムアウト</span>
                            </div>
                            <div class="text-left" v-show="obj.sensor.timeout_winch_up">
                                <span class="red white--text font-weight-bold mx-1 px-3">上昇タイムアウト</span>
                            </div>
                            <!-- ============================================= -->
                            <!--
                            <v-row>
                                <v-col align-self="end">
                                    <h5>{{ obj.site.pref }} {{ obj.site.city }}</h5>
                                    <h5>{{ obj.site.name }}</h5>
                                </v-col>
                                <v-col align-self="end">
                                    <h6 class="text-right">
                                        {{ dateFormat(obj.sensor.modified, "Y年M月D日 HH:mm") }}
                                        <v-icon color="yellow" v-show="chkAlive(obj.device.alived_at)">mdi-alert</v-icon>
                                    </h6>
                                </v-col>
                            </v-row>
                            -->
                            <!-- ============================================= -->
                            <v-simple-table dense>
                                <thead class="blue lighten-3 text-center">
                                    <tr>
                                        <td class="pa-0">{{ obj.config.w1label_top }}</td>
                                        <td class="pa-0">{{ obj.config.w1label_middle }}</td>
                                        <td class="pa-0">{{ obj.config.w1label_bottom }}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h2>{{ roundNumber(obj.sensor.water_top) }}</h2>
                                        </td>
                                        <td>
                                            <h2>{{ roundNumber(obj.sensor.water_middle) }}</h2>
                                        </td>
                                        <td>
                                            <h2>{{ roundNumber(obj.sensor.water_bottom) }}</h2>
                                        </td>
                                    </tr>
                                </thead>
                            </v-simple-table>
                            <!-- ============================================= -->
                        </v-card-text>
                        <h5 class="text-right white--text mx-2">
                            {{ dateFormat(obj.device.alived_at, "Y年M月D日 HH:mm") }}
                            <v-icon color="yellow" v-show="chkAlive(obj.device.alived_at)">mdi-alert</v-icon>
                        </h5>
                    </v-carousel-item>
                    <v-carousel-item>
                        <v-container>
                            <h2 class="white--text ma-2">{{ obj.device.name }}</h2>
                            <v-row>
                                <v-col class="text-center">
                                    <v-btn class="ma-1" :to="{ name: 'DeviceChart', params: { device_id: obj.device.id } }" color="success"><v-icon>mdi-chart-line</v-icon></v-btn>
                                    <v-btn class="ma-1" :to="{ name: 'DeviceImage', params: { device_id: obj.device.id } }" color="yellow"><v-icon>mdi-camera-outline</v-icon></v-btn>
                                    <v-btn class="ma-1" :to="{ name: 'Playback', params: { device_id: obj.device.id } }" color="error" v-show="obj.device.has_videocam"><v-icon>mdi-video-outline</v-icon></v-btn>
                                    <v-btn class="ma-1" :to="{ name: 'WinchSummary', params: { device_id: obj.device.id } }" color="info" v-show="obj.device.has_winch"><v-icon>mdi-cog-outline</v-icon></v-btn>
                                    <v-btn class="ma-1" :to="{ name: 'WinchDetail', params: { device_id: obj.device.id } }" color="success" v-show="obj.device.has_winch"><v-icon>mdi-cog-outline</v-icon></v-btn>
                                    <!--
                                    <v-btn class="ma-1" color="cyan lighten-2">加速度</v-btn>
                                    <v-btn class="ma-1" color="purple lighten-2">自動昇降</v-btn>
                                    -->
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-carousel-item>
                    <v-carousel-item>
                        <v-container>
                            <h2 class="white--text ma-2">{{ obj.device.name }}</h2>
                            <v-row>
                                <v-col class="text-center">
                                    <v-btn class="ma-1" :to="{ name: 'AverageTemp', params: { device_id: obj.device.id } }" color="success">平均水温</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-carousel-item>
                </v-carousel>
            </v-card>
        </div>
        <comp-popup-info />
    </v-container>
</template>

<script>
// @ is an alias to /src
import CompPopupInfo from "@/components/CompPopupInfo";
export default {
    name: "DevicesList",
    components: {
        CompPopupInfo,
    },
    //========================================================
    data() {
        return {
            jwt: "",
            myInfo: [],
            dbSites: [],
            dbDevices: [],
            dbLastSensings: [],
            dbChartConfigs: [],
            deviceTree: [],
            keywordFilter: "",
            isLoading: false,
        };
    },
    //========================================================
    created: async function () {
        this.jwt = this.$localStorage.get("jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return;
        }
        this.myInfo = this.$jwt.decode(this.jwt);
        if (this.myInfo && this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return;
        }
        //-----------------------
        this.isLoading = true;
        //-----------------------
        //非同期でAxiosGet
        const promiseDevice = this.getDevices();
        const promiseSite = this.getSites();
        const promiseSensor = this.getLastSensings();
        const promiseConfig = this.getChartConfigs();
        //-----------------------
        //上記の終了を待つ
        await promiseDevice;
        await promiseSite;
        await promiseSensor;
        await promiseConfig;
        //-----------------------
        //上記が全て取得終了したタイミングで、配列マージする
        //await new Promise((r) => setTimeout(r, 500));
        await this.buildDeviceTree();
        //-----------------------
        this.isLoading = false;
        //-----------------------
        window.scrollTo(0, 0);
    },
    //========================================================
    methods: {
        //====================================================
        async getSites() {
            await this.axios({
                method: "GET",
                url: "/web/api/sites",
                //params: { "_order[sort_no]": "desc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbSites = response.data.json;
            });
        },
        //====================================================
        async getDevices() {
            await this.axios({
                method: "GET",
                url: "/web/api/devices",
                //params: { "_order[id]": "desc" },
                params: { "_order[name]": "asc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbDevices = response.data.json;
            });
        },
        //====================================================
        async getLastSensings() {
            await this.axios({
                method: "GET",
                url: "/web/api/last_sensings",
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbLastSensings = response.data.json;
            });
        },
        //====================================================
        async getChartConfigs() {
            await this.axios({
                method: "GET",
                url: "/web/api/chart_configs",
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbChartConfigs = response.data.json;
            });
        },
        //====================================================
        buildDeviceTree() {
            //----------------------------------------------
            let rating = this.$localStorage.get("rating");
            rating = rating ? JSON.parse(rating) : {};
            //----------------------------------------------
            this.deviceTree = [];
            for (let idx in this.dbDevices) {
                let objDevice = JSON.parse(JSON.stringify(this.dbDevices[idx]));
                let device_id = objDevice.id;
                let site_id = objDevice.site_id;
                let objSite = {};
                let objSensor = {};
                let objConfig = {};
                for (let idx in this.dbSites) {
                    if (site_id == this.dbSites[idx].id) {
                        objSite = this.dbSites[idx];
                        break;
                    }
                }
                for (let idx in this.dbLastSensings) {
                    if (device_id == this.dbLastSensings[idx].device_id) {
                        objSensor = this.dbLastSensings[idx];
                        break;
                    }
                }
                for (let idx in this.dbChartConfigs) {
                    if (device_id == this.dbChartConfigs[idx].device_id) {
                        objConfig = this.dbChartConfigs[idx];
                        break;
                    }
                }
                //------------------------------------
                // キーワードフィルターが「空」or「デバイス名」「組織名」に含まれた場合は表示する。
                let isDisp = false;
                if (!this.keywordFilter) isDisp = true;
                if (String(objDevice.name).toLowerCase().indexOf(this.keywordFilter.toLowerCase(), 0) > -1) isDisp = true;
                if (String(objSite.name).toLowerCase().indexOf(this.keywordFilter.toLowerCase(), 0) > -1) isDisp = true;
                if (String(objSite.pref).toLowerCase().indexOf(this.keywordFilter.toLowerCase(), 0) > -1) isDisp = true;
                if (String(objSite.city).toLowerCase().indexOf(this.keywordFilter.toLowerCase(), 0) > -1) isDisp = true;
                if (isDisp) {
                    objDevice.rating = rating[device_id] ? rating[device_id] : 0;
                    this.deviceTree.push({
                        device: objDevice,
                        site: objSite,
                        sensor: objSensor,
                        config: objConfig,
                    });
                }
            }
            //--------------------------------------------------
            // お気に入り順に、並べ替え
            this.deviceTree.sort(function (a, b) {
                let ret = 0;
                if (a.device.rating > b.device.rating) ret = -1;
                if (a.device.rating < b.device.rating) ret = 1;
                if (a.device.rating == b.device.rating) ret = 0;
                return ret;
            });
            //--------------------------------------------------
        },
        //====================================================
        dateFormat(strDate, format) {
            return this.$moment(strDate).format(format);
        },
        //====================================================
        roundNumber(val) {
            let ret = Math.round(val * 10) / 10;
            ret = ret.toFixed(1);
            return ret;
        },
        //====================================================
        chkAlive(alived_at) {
            if (!alived_at) return false;
            let now = this.$moment().add(-2, "hours");
            let alive = this.$moment(alived_at);
            if (now < alive) return false;
            return true;
        },
        //====================================================
    },
};
</script>
